/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as CollectingRouteImport } from './routes/collecting'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as ReturningRouteImport } from './routes/returning'
import { Route as TransactionsRouteImport } from './routes/transactions'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectingRoute = CollectingRouteImport.update({
  id: '/collecting',
  path: '/collecting',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const ReturningRoute = ReturningRouteImport.update({
  id: '/returning',
  path: '/returning',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/collecting': typeof CollectingRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/returning': typeof ReturningRoute
  '/transactions': typeof TransactionsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/collecting': typeof CollectingRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/returning': typeof ReturningRoute
  '/transactions': typeof TransactionsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/collecting': typeof CollectingRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/returning': typeof ReturningRoute
  '/transactions': typeof TransactionsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/collecting'
    | '/login'
    | '/logout'
    | '/returning'
    | '/transactions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/collecting'
    | '/login'
    | '/logout'
    | '/returning'
    | '/transactions'
  id:
    | '__root__'
    | '/'
    | '/callback'
    | '/collecting'
    | '/login'
    | '/logout'
    | '/returning'
    | '/transactions'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CallbackRoute: typeof CallbackRoute
  CollectingRoute: typeof CollectingRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  ReturningRoute: typeof ReturningRoute
  TransactionsRoute: typeof TransactionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collecting': {
      id: '/collecting'
      path: '/collecting'
      fullPath: '/collecting'
      preLoaderRoute: typeof CollectingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/returning': {
      id: '/returning'
      path: '/returning'
      fullPath: '/returning'
      preLoaderRoute: typeof ReturningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CallbackRoute: CallbackRoute,
  CollectingRoute: CollectingRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  ReturningRoute: ReturningRoute,
  TransactionsRoute: TransactionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
